import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  paper: {
    position: 'absolute',
    width: '80%',
    height: 650,
    overflowY: 'auto',
    overflowX: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  recordCell: {
    paddingRight: '5px',
    wordBreak: 'break-all',
  },
  pageControls: {
    width: '100%',
    alignContent: 'right',
  },
});
